import { render } from "./kanban-board.vue?vue&type=template&id=18d2fa46&scoped=true"
import script from "./kanban-board.vue?vue&type=script&lang=js"
export * from "./kanban-board.vue?vue&type=script&lang=js"

import "./kanban-board.vue?vue&type=style&index=0&id=18d2fa46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d2fa46"]])

export default __exports__